import { Flex } from "@chakra-ui/react";

interface CardProps {
  variant?: "primary" | "secondary";
  children: React.ReactNode;
  maxWidth?: string;
  minHeight?: string;
}

const Card = ({ children, variant = "primary", maxWidth = "100%", minHeight }: CardProps) => {
  const primaryVariant = () => {
    return (
      <Flex
        w="100%"
        flexDir="column"
        gap="4"
        borderRadius="8px"
        bgColor="white"
        shadow="md"
        padding="1.5rem"
        maxWidth={maxWidth}
      >
          {children}
      </Flex>
    )
  }

  const secondaryVariant = () => {
    return (
      <Flex
        width="100%"
        flexDir="column"
        gap="1rem"
        borderRadius="4px"
        bgColor="white"
        border="1px solid"
        borderColor="gray.50"
        padding=".8rem"
        maxWidth={maxWidth}
        {...minHeight && { minH: minHeight }}
      >
        {children}
      </Flex>
    )
  }

  const formatVariant = (variant: string) => {
    const variants = {
      primary: primaryVariant,
      secondary: secondaryVariant,
    }

    return variants[variant];
  }

  return formatVariant(variant)();
};

export default Card;
